export const SELECTED_RING_LOCAL_STORAGE_KEY = 'selectedRing';
